module.exports = __webpack_public_path__ + "static/media/mama-burger2-dt-fr.32224bca.jpg";